const initState = {
  isLogin: null, // null: 方便判断是否打接口了
  isAdmin: false,
  userInfo: {},
  taskList: {
    accumulate_sign: [],
    palcode: [
      // {
      //   bonus: "5000",
      //   description: "{\"subTitle\":\"邀请好友\",\"desc\":\"具体逻辑不走task规则\",\"extcredit2\":\"2000\"}",
      // }
    ],
    post: [],
    sign: [],
    sign_task_credit: 0,
    usergroups: []
  },
  palcodeInfo: {
    flag: 0,
    my_palcode: "", // uQfhYYf
    parent_palcode: "",
    status: -1, // 不是 -1 为成功
  },
  myThread: {
    list: [],
    pageSize: 20, // 一页几笔
    total: 0, // 总笔数
    page: 1, // 第几页
    pages: 1, // 总页数
  },
  myReply: {
    list: [],
    pageSize: 20,
    total: 0,
    page: 1,
    pages: 1,
  },
  myDonate: {
    list: [],
    pageSize: 20,
    total: 0,
    page: 1,
    pages: 1,
  },
  myFavorite: {
    list: [],
    pageSize: 20,
    total: 0,
    page: 1,
    pages: 1,
  },
  myPersonalNotice: {
    unread: 0, // 未读
    list: [],
    pageSize: 20,
    total: 0,
    page: 1,
    pages: 1,
  },
  mySystemNotice: {
    unread: 0, // 未读
    list: [],
    pageSize: 20,
    total: 0,
    page: 1,
    pages: 1,
  },
  memoriesInfo : { 'init': true }
}

const state = Object.assign({}, initState)

export {
  initState,
  state
}